module.exports = __webpack_public_path__ + "static/bg5-0b37f7db5bf7d7c1b023360ed53db140.jpg";